import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    staticClass: "warehouse-importer-add-edit-modal",
    attrs: {
      "width": 800,
      "data-sign": "wrapper_add_edit_modal",
      "title": _vm.rowData.title
    },
    on: {
      "cancel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "rules": _vm.formDataRule,
      "data-sign": "wrapper_add_edit_form",
      "model": _vm.formData
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8017\u6750\u7C7B\u578B"),
      "prop": "consumables_type",
      "label": _vm.t('耗材类型')
    }
  }, [_vm._v(" " + _vm._s(_vm.t('包材')) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5305\u88C5\u7C7B\u578B"),
      "prop": "package_category",
      "label": _vm.t('包装类型')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择包装类型')
    },
    model: {
      value: _vm.formData.package_category,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "package_category", $$v);
      },
      expression: "formData.package_category"
    }
  }, _vm._l(_vm.packageCategoryEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": String(item.value)
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u7F16\u7801"),
      "prop": "package_code",
      "label": _vm.t('包材编码')
    }
  }, [_c('div', {
    staticClass: "flex-box"
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请输入包材编码')
    },
    on: {
      "blur": _vm.handlePackageCodeBlur
    },
    model: {
      value: _vm.formData.package_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "package_code", $$v);
      },
      expression: "formData.package_code"
    }
  }), _c('div', {
    staticClass: "note-tip"
  }, [_vm._v(_vm._s(_vm.t('包材编码中的小写字母将自动转换为大写')))])], 1)]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u540D\u79F0"),
      "prop": "package_name",
      "label": _vm.t('包材名称')
    }
  }, [_c('my-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请输入包材名称')
    },
    model: {
      value: _vm.formData.package_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "package_name", $$v);
      },
      expression: "formData.package_name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u9002\u7528\u4ED3\u5E93\uFF08\u533A\u57DF\uFF09"),
      "prop": "warehouse_code_list",
      "label": _vm.t('适用仓库（区域）')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "maxTagCount": 1,
      "mode": "multiple",
      "placeholder": _vm.t('请选择适用仓库（区域）')
    },
    model: {
      value: _vm.formData.warehouse_code_list,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "warehouse_code_list", $$v);
      },
      expression: "formData.warehouse_code_list"
    }
  }, _vm._l(_vm.rowData.warehouseList || [], function (item) {
    return _c('a-select-option', {
      key: item.warehouse_code,
      attrs: {
        "value": item.warehouse_code
      }
    }, [_vm._v(" " + _vm._s(item.warehouse_name_text) + " ")]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5C3A\u5BF8\uFF08cm\uFF09"),
      "label": _vm.t('尺寸（cm）'),
      "required": ""
    }
  }, [_c('a-form-model-item', {
    staticClass: "input-inline",
    attrs: {
      "prop": "inner_box_length"
    }
  }, [_c('a-input-number', {
    staticClass: "inline-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('长')
    },
    model: {
      value: _vm.formData.inner_box_length,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "inner_box_length", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.inner_box_length"
    }
  })], 1), _c('a-form-model-item', {
    staticClass: "input-inline",
    attrs: {
      "prop": "inner_box_width"
    }
  }, [_c('a-input-number', {
    staticClass: "inline-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('宽')
    },
    model: {
      value: _vm.formData.inner_box_width,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "inner_box_width", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.inner_box_width"
    }
  })], 1), _c('a-form-model-item', {
    staticClass: "input-inline",
    attrs: {
      "prop": "inner_box_height"
    }
  }, [_c('a-input-number', {
    staticClass: "inline-input",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('高')
    },
    model: {
      value: _vm.formData.inner_box_height,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "inner_box_height", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.inner_box_height"
    }
  })], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u91CD\u91CF\uFF08kg\uFF09"),
      "prop": "weight",
      "label": _vm.t('重量（kg）')
    }
  }, [_c('a-input-number', {
    staticClass: "inline-input",
    model: {
      value: _vm.formData.weight,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "weight", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.weight"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u6700\u5927\u627F\u91CD\uFF08kg\uFF09"),
      "prop": "max_weight",
      "label": _vm.t('最大承重（kg）')
    }
  }, [_c('a-input-number', {
    staticClass: "inline-input",
    model: {
      value: _vm.formData.max_weight,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "max_weight", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.max_weight"
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "wrapper_add_cancel",
      "id": "wrapper_add_cancel",
      "data-sign": "wrapper_add_edit_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "data-permission": "wrapper_add_save",
      "id": "wrapper_add_save",
      "type": "primary",
      "data-sign": "wrapper_add_edit_submit",
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };